export default __webpack_public_path__ + "static/week6-2eafe8b7ed118a30339d67ed29c6fc31.png";